module.exports = ".info-detail {\r\n   \r\n    border: 1px #999999 solid;\r\n    background: white;\r\n    width: 200px;\r\n\r\n}\r\n.close {\r\n    padding :0 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/appointment/calendar/show-task.component.css
// module id = ./src/app/section/appointment/calendar/show-task.component.css
// module chunks = main